import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => (
  <a
    href="https://wa.me/18762980309?text=Hi%20TLF%20DESIGNZ!%20I%20have%20a%20print%20job%20to%20discuss."
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-chat-button"
    aria-label="Chat with TLF DESIGNZ on WhatsApp"
    className="fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_30px_rgba(37,211,102,0.35)] transition-transform duration-300 hover:scale-110"
  >
    <MessageCircle className="h-7 w-7" />
  </a>
);

export default WhatsAppButton;
